// extracted by mini-css-extract-plugin
export default {"table":"SimpleTable_table__1SPAJ","tableStriped":"SimpleTable_tableStriped__HvT4C","active":"SimpleTable_active__Der25","tableHover":"SimpleTable_tableHover__qqgdx"};